"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseInAppAgentInterruptEvent = parseInAppAgentInterruptEvent;
const core_1 = require("@ag-ui/core");
const zod_1 = require("zod");
const json_1 = require("../utils/json");
const MastraSuspendEventSchema = zod_1.z.object({
    type: zod_1.z.literal("mastra_suspend"),
    toolCallId: zod_1.z.string().min(1),
    toolName: zod_1.z.string().min(1),
    args: zod_1.z.unknown().optional(),
    runId: zod_1.z.string().min(1),
});
/** Parses the durable interrupt event shape in browser and server runtimes. */
function parseInAppAgentInterruptEvent(event) {
    if (!event ||
        typeof event !== "object" ||
        !("type" in event) ||
        event.type !== core_1.EventType.CUSTOM ||
        !("name" in event) ||
        event.name !== "on_interrupt") {
        return undefined;
    }
    const value = "value" in event ? event.value : undefined;
    const parsedValue = typeof value === "string" ? (0, json_1.safeJsonParse)(value) : value;
    const interrupt = MastraSuspendEventSchema.safeParse(parsedValue);
    return interrupt.success
        ? { ...interrupt.data, type: "tool_approval_request" }
        : undefined;
}
